import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-composer-root',
  templateUrl: './composer-root.component.html',
  styleUrls: ['./composer-root.component.scss']
})
export class ComposerRootComponent implements OnInit {

  constructor( private _router: Router) { }

  ngOnInit(): void {
  }
  isActive(tab:string) {
    return this._router.url.includes(tab);
  }
}
